import promisifyObserver from '../utils/promisifyObserver.js';

const entryType = 'paint';

export default function fcp(window, performance, PerformanceObserver) {
    const paints = {
        entryType
    };
    return promisifyObserver(PerformanceObserver, entryType, (entries, resolve) => {
        let done = false;
        entries.forEach(({name, startTime}) => {
            paints[name] = Math.round(startTime);
            if (name === 'first-contentful-paint') {
                done = true;
            }
        });
        if (done) {
            resolve(paints);
        }
    });
}
